package com.flowyride.core.designsystem.theme

import androidx.compose.ui.graphics.Color

// Palette: warm "sunset ride" orange on asphalt greys.
internal val Orange40 = Color(0xFFB34700)
internal val Orange80 = Color(0xFFFFB68C)
internal val Orange90 = Color(0xFFFFDBC9)
internal val Orange10 = Color(0xFF351000)
internal val Asphalt10 = Color(0xFF1A1C1E)
internal val Asphalt20 = Color(0xFF2F3033)
internal val Asphalt90 = Color(0xFFE2E2E6)
internal val Asphalt95 = Color(0xFFF1F0F4)
internal val Asphalt99 = Color(0xFFFDFBFF)
internal val Teal40 = Color(0xFF00696E)
internal val Teal80 = Color(0xFF4FD8E0)

/** Colors that are not part of the Material scheme. */
object FlowyColors {
    val RouteLine = Color(0xFFE65100)
    val RouteCasing = Color(0xFFFFFFFF)
    val Departure = Color(0xFF2E7D32)
    val Arrival = Color(0xFFC62828)
    val Stop = Color(0xFF1565C0)

    // Route line by speed limit, from what a rider avoids (red: villages) to what they look for (violet: open roads).
    val SpeedTown = Color(0xFFD32F2F)
    val SpeedSlow = Color(0xFFF57C00)
    val SpeedRoad = Color(0xFF7B1FA2)
    val SpeedFast = Color(0xFF1E88E5)
    val SpeedUnknown = Color(0xFF90A4AE)
}
